<label class="custom-checkbox">
  <input
    type="checkbox"
    [checked]="checked"
    (click)="onClick()"
    [attr.disabled]="readOnly ? '' : null"
  />
  <span
    class="checkmark {{ color }}"
    [ngStyle]="{ 'width.px': size, 'height.px': size }"
  ></span>
</label>
